module.exports = __webpack_public_path__ + "static/actionbar-spellnumbers-dont-726647e536ad74f1a6ff5c341dcda9a2.png";